import axios from "axios";
import { Apis } from "../../config";

export const createCallbackRequest = async (data) => {
    try {
        const result = await axios.post(Apis.CreateCallbackRequest, data);
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
        console.log(error)
        return error.response?.data;
    }
}
